module.exports = __webpack_public_path__ + "img/图2.0e6bda3d.png";